import { render } from "./templateFooter.vue?vue&type=template&id=d25d8ba4&scoped=true"
import script from "./templateFooter.vue?vue&type=script&lang=js"
export * from "./templateFooter.vue?vue&type=script&lang=js"

import "./templateFooter.vue?vue&type=style&index=0&id=d25d8ba4&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25d8ba4"]])

export default __exports__